import React from 'react';
import { Route } from 'react-router-dom';

const PublicRoute = ({ component: Component, authed, ...rest }) => (
  <Route
    {...rest}
    render={(props) => (
      <Component isAuthenticated={authed} {...props} />
    )}
  />
);

export default PublicRoute;
